<template>
  <div class="live-list-wrapper">

    <w-navbar icon="iconchevron-left"
              nav_title="直播招聘"
              @mobileLeftBtn="goBackFun()"/>

    <div class="live-list">

      <div class="live-item" v-for="(item, index) in liveList" :key="`liveItem&${index}`" @click="toLiveDetail(item)">

        <div class="live-item-top" :style="{'background-image': `url(${item.img})`}">
          
          <!-- 直播预约顶部信息 -->
          <div class="live-item-header">
            <img class="live-company-logo" :src="item.company_info.company_logo" alt="">
            <div class="live-item-header-text">
              <div class="title-big">
                <div class="hot-title">{{ item.title }}</div>
                <div class="hot-reservation" v-if="item.status === 'start'">
                  <img src="https://files.wondercv.com/m/zhibo/campfire%403x.png" alt="" />
                  <span>火热预约</span>
                </div>
              </div>
              <div class="title-small">{{ item.desc }}</div>
            </div>

          </div>
          <!-- 直播预约底部信息 -->
          <div class="content-bottom">
            <div class="liveReservation" v-if="item.status === 'start'">
            <div class="live-status">直播</div>
            <div class="live-time">
              <span>{{ item.start_at | formateTime }}</span>
            </div>
            </div>
            
          <!-- 正在直播底部信息 -->
          <div class="living" v-else-if="item.status === 'progress'">
            <i class="iconfont iconzhibozhong"></i>
            <span>正在直播中...</span>
          </div>
          
          <!-- 直播结束底部信息 -->
          <div class="live-playback" v-else-if="item.status=='end'">
            <div class="live-status">已结束</div>
            <div class="live-time">
              <span>{{ item.end_at | formateTime }}</span>
            </div>
          </div>
          </div>
        </div>

        <div class="live-item-bottom">

          <div class="live-info-text">
            <div class="reservation-count">
              <i class="iconfont iconrenshu" style="margin-right: 5px"></i>
              <span>{{ item.appoint_count }}人预约</span>
            </div>
            <div class="recruit-count">
              <i class="iconfont iconzhiwei1" style="margin-right: 5px"></i>
              <span>{{ item.company_info.jobs_count }}在招</span>
            </div>
          </div>

          <div class="live-info-btn">
            <i class="iconfont" :class="btnMap[item.status].icon"></i>
            <span>{{ btnMap[item.status].text }}</span>
          </div>

        </div>

      </div>

    </div>
  
  </div>
</template>

<script>
import moment from 'moment'
import WNavbar from '@/components/global/w-navbar'

export default {
  data(){
    return{
      liveList: [], // 直播入口列表
      btnMap: {
        start: {
          icon: 'icona-lijiyuyue3x',
          text: '立即预约'
        },
        progress: {
          icon: 'icona-lijiguankan3x',
          text: '立即观看'
        },
        end: {
          icon: 'icona-guankanhuifang3x',
          text: '观看回放'
        }
      }
    }
  },
  components: {
    WNavbar
  },
  created () {
    // 获取直播列表
    this.getLiveList()
  },
  filters:{
    formateTime(val){
      return moment(val).format("MM-DD HH:mm")
    }
  },
  methods: {
    // 获取直播列表
    async getLiveList () {
      try {
        let res = await this.$api.live.getLiveList()
        if (res.code === 1000) {
          let list = res.data.lives || []

          // 每个直播 直播状态赋值
          list && list.length && list.forEach(item => {
            let date = new Date().valueOf()
            let startTime = new Date(item.start_at).valueOf()
            let endTime = new Date(item.end_at).valueOf()
            // 未开始
            if (startTime > date) {
              item.status = 'start'
            // 正在直播中
            } else if (startTime <= date && date <= endTime) {
              item.status = 'progress'
            // 已经结束
            } else {
              item.status = 'end'
            }
          })

          this.liveList = list
        }
        
      } catch (e) {
        console.log('获取直播列表错误：', e)
      }
    },
    // 跳转到直播详情页
    toLiveDetail (item) {
      this.$router.push(`/live/${item.token}`)
    },
    // 页面返回
    goBackFun () {
      this.$router.back()
    }
  }
};
</script>

<style scope lang="scss">
  @import './index.scss';
</style>
